module.exports = __webpack_public_path__ + "static/media/user1.a2c44c39.svg";